<button class="close" mat-button (click)="close()">X</button>
<h3 mat-dialog-title>Add or remove group.</h3>
<mat-dialog-content class="change-bg">
    <mat-form-field>
        <input matInput type="text" placeholder="Search" [(ngModel)]="searchText" (ngModelChange)="mychange($event)">
        <button mat-button matSuffix mat-icon-button>
          <mat-icon>search</mat-icon>
        </button>
      </mat-form-field>
    <h5>Selected Grups</h5>
    <mat-card>
        <div *ngFor="let data of rowList">
            <mat-chip-list>
                <mat-chip >
                    {{data}}
                    <mat-icon matChipRemove >cancel</mat-icon>
                </mat-chip>
            </mat-chip-list>
                
        </div>
    </mat-card>
    <h5>Grups Suggestion</h5>
    <mat-card>
        <div *ngFor="let data of allGroups">
            <mat-card>{{data.name}}</mat-card>
        </div>
    </mat-card>
</mat-dialog-content>

<mat-dialog-actions>
    <button class="mat-raised-button mat-primary"(click)="updateBoardMember(data)">Update</button>
</mat-dialog-actions> 